<template>
  <v-container>
    <v-layout justify-center>
      <v-card style="position: fixed">
        <v-btn-toggle v-model="seatType" mandatory>
          <v-btn flat :value="0">
            <span>SEAT</span>
            <v-icon>event_seat</v-icon>
          </v-btn>
          <v-btn flat :value="3">
            <span>BLOCK</span>
            <v-icon>block</v-icon>
          </v-btn>
          <v-btn flat :value="4">
            <span>Comfort Room</span>
            <v-icon>wc</v-icon>
          </v-btn>
          <v-btn flat :value="5">
            <span>Driver</span>
            <v-icon>gamepad</v-icon>
          </v-btn>
          <v-btn flat :value="7">
            <span>Door</span>
            <v-icon>meeting_room</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-card>
    </v-layout>
    <v-layout justify-center class="mt-5">
      <v-flex md1>
        <v-container fill-height>
          <v-layout align-center justify-center>
            <span class="font-weight-black">BACK</span>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex md10>
        <v-layout justify-center v-for="layout in data" :key="layout.index">
          <v-container>
            <v-layout justify-center>
              <span class="font-weight-black">Floor: {{layout.floor_no}}</span>
            </v-layout>
            <v-layout class="scrolling-wrapper">
              <v-flex v-for="col in layout.column" :key="col.index">
                <v-container class="ma-0 pa-0">
                  <v-layout v-for="row in col.data" :key="row.index">
                    <a @click="openDialog(row)">
                      <icon-seat
                        v-if="row.status===0"
                        :pointer="true"
                        :seatName="row.seat_name.toString()"
                        color="#0d72b9"
                      ></icon-seat>
                      <icon-seat
                        v-if="row.status===3"
                        :pointer="true"
                        :seatName="row.seat_name.toString()"
                        color="gray"
                      ></icon-seat>
                      <icon-toilet v-if="row.status===4"></icon-toilet>
                      <icon-driver v-if="row.status===5"></icon-driver>
                      <icon-blank v-if="row.status===6"></icon-blank>
                      <icon-door v-if="row.status===7"></icon-door>
                      <icon-blank v-if="row.status===8"></icon-blank>
                    </a>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-flex>
      <v-flex md1>
        <v-container fill-height>
          <v-layout align-center justify-center>
            <span class="font-weight-black">FRONT</span>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="400" persistent>
      <v-card>
        <v-container>
          <v-layout>
            <v-text-field
              label="Seat Name"
              @keyup.enter.native="enterSeatName"
              ref="txt"
              v-model="seat.seat_name"
              :rules="rules"
            ></v-text-field>
          </v-layout>
          <v-layout>
            <v-flex md6 class="mr-2">
              <v-btn block class="primary" @click="cancelSeatName()">Cancel</v-btn>
            </v-flex>
            <v-flex md6 class="ml-2">
              <v-btn block class="primary" @click="enterSeatName()">Confirm</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Array
  },
  data() {
    return {
      dialog: false,
      seat: {},
      seatType: 0,
      selection: [
        { text: "Passenger Seat", value: 0 },
        { text: "Block", value: 3 },
        { text: "Comfort Room", value: 4 },
        { text: "Driver Seat", value: 5 },
        { text: "Door", value: 7 },
        { text: "Stairs", value: 8 }
      ],
      rules: [v => !!v || "This field is required"],
      seat_name: "",
      toggle_one: 0
    };
  },
  computed: {
    computedData() {
      return this.data;
    }
  },
  methods: {
    selectSeat(data) {
      return data;
    },
    enterSeatName() {
      this.seat_name = this.seat.seat_name;

      if (
        this.seat.seat_name !== null &&
        this.seat.seat_name !== undefined &&
        this.seat.seat_name !== ""
      ) {
        this.dialog = false;
      }
    },
    cancelSeatName() {
      this.seat.status = 6;
      this.seat.seat_name = "";
      this.dialog = false;
    },
    // isDuplicate() {
    // this.data.forEach(floor => {
    //   floor.column.forEach(col => {
    //     col.data.forEach(seat => {
    //       if (this.seat.seat_name === seat.seat_name) {
    //         console.log(seat.seat_name);
    //       }
    //     });
    //   });
    // console.log(this.seat.seat_name);
    // console.log(seat.seat_name);
    // if (this.seat.seat_name === seat.seat_name) {
    // return 1;
    // }
    // });
    // return 0;
    // },
    openDialog(data) {
      this.seat = data;
      if (data.status === this.seatType) {
        this.seat.status = 6;
        this.seat.seat_name = "";
      } else {
        this.seat.status = this.seatType;
        if (this.seat.status === 0 || this.seat.status === 3) {
          this.dialog = true;
          this.$nextTick(this.$refs.txt.focus);
        }
      }
    }
  }
};
</script>

<style>
.scrolling-wrapper {
  overflow-y: hidden;
  width: auto;
  overflow-x: auto;
}
</style>
